export default __webpack_public_path__ + "static/diag-dash-25b982fde65a66789aa8f95b823a7b8a.webp";